import { createApp } from 'vue';
import ResortBubble from './vue/resort-bubble.vue';
import { context } from './resort-bubble.config.yml';


const app = createApp(ResortBubble, context);
app.mount('#resort-bubble-root');
